// extracted by mini-css-extract-plugin
module.exports = {"title":"EventEditTestPage_title__1-QIK","buttonFooter":"EventEditTestPage_buttonFooter__1bXcs","link":"EventEditTestPage_link__gyVyp","mr_10":"EventEditTestPage_mr_10__1UlQi"};